<mat-paginator [pageSizeOptions]="defaultPageSizeOptions"
               (page)="changePageSize($event)"
               [pageSize]="currentPageSize"
               [length]="paginatorLength"
               [pageIndex]="paginatorPageIndex"
               showFirstLastButtons
               attr.aria-label="{{'Select page of periodic elements' | translate}}">
</mat-paginator>
